import { useEffect } from 'react';

import { useAuth, useOrganization, useOrganizationList } from '@clerk/clerk-react';

interface OrganizationProviderProps {
  children: React.ReactNode;
}

export const OrganizationProvider: React.FC<OrganizationProviderProps> = ({ children }) => {
  const { isLoaded: isAuthLoaded, isSignedIn } = useAuth();
  const { organization, isLoaded: isOrgLoaded } = useOrganization();
  const { setActive, userMemberships } = useOrganizationList({
    userMemberships: {
      infinite: true
    }
  });

  useEffect(() => {
    if (!isAuthLoaded || !isOrgLoaded || !isSignedIn) {
      return;
    }

    if (organization) {
      console.log('[OrganizationProvider] Active organization:', organization.id, organization.name);
      return;
    }

    // If user has no organizations, show error
    if (!userMemberships.data || userMemberships.data.length === 0) {
      console.error(
        '[OrganizationProvider] User has no organizations. Multi-tenancy requires organization membership.'
      );
      return;
    }

    const firstOrg = userMemberships.data[0]?.organization;
    if (!firstOrg) {
      console.error('[OrganizationProvider] First organization is undefined.');
      return;
    }

    void setActive?.({ organization: firstOrg.id });
  }, [isAuthLoaded, isOrgLoaded, isSignedIn, organization, userMemberships, setActive]);

  return <>{children}</>;
};
